/* Lazy Load XT 1.1.0 | MIT License */
!function(a,b,c,d){function e(a,b){return a[b]===d?t[b]:a[b]}function f(){var a=b.pageYOffset;return a===d?r.scrollTop:a}function g(a,b){var c=t["on"+a];c&&(w(c)?c.call(b[0]):(c.addClass&&b.addClass(c.addClass),c.removeClass&&b.removeClass(c.removeClass))),b.trigger("lazy"+a,[b]),k()}function h(b){g(b.type,a(this).off(p,h))}function i(c){if(z.length){c=c||t.forceLoad,A=1/0;var d,e,i=f(),j=b.innerHeight||r.clientHeight,k=b.innerWidth||r.clientWidth;for(d=0,e=z.length;e>d;d++){var l,m=z[d],q=m[0],s=m[n],u=!1,v=c||y(q,o)<0;if(a.contains(r,q)){if(c||!s.visibleOnly||q.offsetWidth||q.offsetHeight){if(!v){var x=q.getBoundingClientRect(),B=s.edgeX,C=s.edgeY;l=x.top+i-C-j,v=i>=l&&x.bottom>-C&&x.left<=k+B&&x.right>-B}if(v){m.on(p,h),g("show",m);var D=s.srcAttr,E=w(D)?D(m):q.getAttribute(D);E&&(q.src=E),u=!0}else A>l&&(A=l)}}else u=!0;u&&(y(q,o,0),z.splice(d--,1),e--)}e||g("complete",a(r))}}function j(){B>1?(B=1,i(),setTimeout(j,t.throttle)):B=0}function k(a){z.length&&(a&&"scroll"===a.type&&a.currentTarget===b&&A>=f()||(B||setTimeout(j,0),B=2))}function l(){v.lazyLoadXT()}function m(){i(!0)}var n="lazyLoadXT",o="lazied",p="load error",q="lazy-hidden",r=c.documentElement||c.body,s=b.onscroll===d||!!b.operamini||!r.getBoundingClientRect,t={autoInit:!0,selector:"img[data-src]",blankImage:"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",throttle:99,forceLoad:s,loadEvent:"pageshow",updateEvent:"load orientationchange resize scroll touchmove focus",forceEvent:"lazyloadall",oninit:{removeClass:"lazy"},onshow:{addClass:q},onload:{removeClass:q,addClass:"lazy-loaded"},onerror:{removeClass:q},checkDuplicates:!0},u={srcAttr:"data-src",edgeX:0,edgeY:0,visibleOnly:!0},v=a(b),w=a.isFunction,x=a.extend,y=a.data||function(b,c){return a(b).data(c)},z=[],A=0,B=0;a[n]=x(t,u,a[n]),a.fn[n]=function(c){c=c||{};var d,f=e(c,"blankImage"),h=e(c,"checkDuplicates"),i=e(c,"scrollContainer"),j=e(c,"show"),l={};a(i).on("scroll",k);for(d in u)l[d]=e(c,d);return this.each(function(d,e){if(e===b)a(t.selector).lazyLoadXT(c);else{var i=h&&y(e,o),m=a(e).data(o,j?-1:1);if(i)return void k();f&&"IMG"===e.tagName&&!e.src&&(e.src=f),m[n]=x({},l),g("init",m),z.push(m),k()}})},a(c).ready(function(){g("start",v),v.on(t.updateEvent,k).on(t.forceEvent,m),a(c).on(t.updateEvent,k),t.autoInit&&(v.on(t.loadEvent,l),l())})}(window.jQuery||window.Zepto||window.$,window,document),function(a){var b=a.lazyLoadXT;b.selector+=",video,iframe[data-src]",b.videoPoster="data-poster",a(document).on("lazyshow","video",function(c,d){var e=d.lazyLoadXT.srcAttr,f=a.isFunction(e),g=!1;d.attr("poster",d.attr(b.videoPoster)),d.children("source,track").each(function(b,c){var d=a(c),h=f?e(d):d.attr(e);h&&(d.attr("src",h),g=!0)}),g&&this.load()})}(window.jQuery||window.Zepto||window.$);
/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

/* !!! Модифицированный модуль !!! Простой апгрейд невозможен */
/**
* version 1.1.0
* upgrades 
* - fade animation on open and close
* - open method. can open modal without binding link
* - possible to open modal with "POST". nessecary when need to send large amount of data to modal
*/

(function ($) {

    $.modalLinkDefaults = {
            height: 600,
            width: 900,
            showTitle: true,
            showClose: true,
            overlayOpacity: 0.6,
            method: "GET", // GET, POST, REF, CLONE
            disableScroll: true,
            onHideScroll: function () { },
            onShowScroll: function () { }
    };

    function hideBodyScroll(cb) {
        scrollWidth = window.innerWidth - document.documentElement.clientWidth;
        $('.header__layout').css( 'padding-right', scrollWidth);

        var w = $("body").outerWidth();
        $("body").css({ overflow: "hidden" });
        var w2 = $("body").outerWidth();
        $("body").css({ width: w });

        if (typeof cb == "function") {
            var scrollbarWidth = w2 - w;
            cb(scrollbarWidth);
        }
    }

    function showBodyScroll(cb) {
        $('.header__layout').css( 'padding-right', 0);
        var $body = $("body");
        var w = $body.outerWidth();
        $body.css({ width: '', overflow: '' });
        var w2 = $body.outerWidth();

        if (typeof cb == "function") {
            var scrollbarWidth = w - w2; 
            cb(scrollbarWidth);
        }
    }

    /**
     * Helper method for appending parameter to url
     */
    function addUrlParam(url, name, value) {
        return appendUrl(url, name + "=" + value);
    }

    /**
     * Hepler method for appending querystring to url
     */
    function appendUrl(url, data) {
        return url + (url.indexOf("?") < 0 ? "?" : "&") + data;
    }

    function buildOptions(option) {
        
    }
    
    function resolveBooleanValue($link) {
        
        for (var i = 1; i < arguments.length; i++) {
            var val = arguments[i];
            
            if (typeof val == "boolean") {
                return val;
            }
            
            if (typeof val == "string") {
                var attrValue = $link.attr(val);
                if (attrValue) {
                    if (attrValue.toLowerCase() === "true") {
                        return true;
                    }
                    if (attrValue.toLowerCase() === "false") {
                        return false;
                    }
                }
            }
        }
    }

    var methods = {
        init: function (options) {
            
            var settings = $.extend({}, $.modalLinkDefaults);
            $.extend(settings, options);

            return this.each(function () {
                var $link = $(this);
                
                // already bound
                if ($link.hasClass("sparkling-modal-link"))
                    return;
                
                // mark as bound
                $link.addClass("sparkling-modal-link");

                $link.click(function (e) {
                    e.preventDefault();
                    methods.open($link, settings);
                    return false;
                });
            });
        },
        
        close: function (cb) {

            var $container = $(".sparkling-modal-container");

            var $link = $container.data("modallink");

            if (!$link) {
                return;
            }

            $link.trigger("modallink.close");

            var $overlay = $container.find(".sparkling-modal-overlay");
            var $content = $container.find(".sparkling-modal-frame");

            $overlay.fadeTo("fast", 0);
            $content.animate({'left':'100%'},500, function() {
                $container.remove();
                showBodyScroll(cb);
                if (typeof cb == "function") {
                    cb();
                }
            });
        },
        
        open: function ($link, options) {

            options = options || {};
            var url, title, showTitle, showClose, disableScroll;

            url = options.url || $link.attr("href");
            title = options.title 
                || $link.attr("data-ml-title")
                || $link.attr("title")
                || $link.text();
                        
            showTitle = resolveBooleanValue($link, 
                options.showTitle, 
                "data-ml-show-title", 
                $.modalLinkDefaults.showTitle);
                           
            showClose = resolveBooleanValue($link,
                options.showClose,
                "data-ml-show-close",
                $.modalLinkDefaults.showClose);
                           
            disableScroll = resolveBooleanValue($link,
                options.disableScroll,
                "data-ml-disable-scroll",
                $.modalLinkDefaults.disableScroll);
            
            var settings = $.extend({}, $.modalLinkDefaults);
            $.extend(settings, options);

            var dataWidth = $link.attr("data-ml-width");
            if (dataWidth) {
                settings.width = parseInt(dataWidth);
            }
            var dataHeight = $link.attr("data-ml-height");
            if (dataHeight) {
                settings.height = parseInt(dataHeight);
            }

            if (settings.method !== "CLONE" && url.length > 0 && url[0] === "#") {
                settings.method = "REF";
            }

            if (settings.method == "GET" || settings.method == "POST") {
                url = addUrlParam(url, "inmodal", "true");
            }

            var data = {};

            if (typeof settings.data != 'undefined') {
                if (typeof settings.data == "function") {
                    data = settings.data();
                }
                else {
                    data = settings.data;
                }
            }

            var $container = $("<div class=\"sparkling-modal-container\"></div>");
            $container.data("modallink", $link);

            var $overlay = $("<div class=\"sparkling-modal-overlay\"></div>");
            $overlay.css({ position: 'fixed', top: 0, left: 0, opacity: 0, width: '100%', height: '100%', zIndex: 999 });
            $overlay.appendTo($container);

            var $content = $("<div class=\"sparkling-modal-frame\"></div>")
                .css({ zIndex: 1000, position: 'fixed' })
                .css({ left: '100%', marginLeft: 0 })
                .css({ top: '0%', marginTop: 0 })
                .css({ width: '100%', height: '100%' })
                .appendTo($container);
            
            if ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
                $content.css({ overflow: 'auto', '-webkit-overflow-scrolling': 'touch' });
            }
            
            
            $("body").append($container);

            if (showTitle) {
                
                var $title = $("<div class=\"sparkling-modal-title\"></div>");
                $title.appendTo($content);
                $title.append($("<span></span>").html(title));

                if (showClose) {
                    var $closeButton = $("<div class=\"sparkling-modal-close\"><div class='i-close'><div class='i-close-h' /><div class='i-close-v' /></div></div>");
                    $closeButton.appendTo($title);
                    $closeButton.click(methods.close);
                }
                
                $title.append("<div style=\"clear: both;\"></div>");
            }
            var $iframeContainer = $("<div class=\"sparkling-modal-content\"></div>");
            $iframeContainer.appendTo($content);

            var $iframe;
            if (settings.method == "REF") {
                $iframe = $("<div />");
                $iframe.css("overflow", "auto");

                var $ref = $(url);
                var id = "ref_" + new Date().getTime();
                var $ph = $("<div id='" + id + "' />");
                $ph.insertAfter($ref);

                $ref.appendTo($iframe);

                $link.on("modallink.close", function() {
                    $ph.replaceWith($ref);
                });

            } else {
                $iframe = $("<iframe frameborder=0 id='modal-frame' name='modal-frame'></iframe>");
            }

            $iframe.appendTo($iframeContainer);
            //$iframe.css({ width: settings.width, height: settings.height });
            
            if ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
                $iframe.css({ width: settings.width, height: document.documentElement.clientHeight });
            }	
            else {
                $iframe.css({ width: settings.width, height: settings.height });
            }



            if (settings.method == "CLONE") {
                console.log(url);
                var $inlineContent = $(url);
                console.log($inlineContent);

                var iFrameDoc = $iframe[0].contentDocument || $iframe[0].contentWindow.document;
                iFrameDoc.write($inlineContent.html());
                iFrameDoc.close();
            }
            else if (settings.method == "GET") {
                if (typeof data == "object") {
                    for (var i in data) {
                        if (data.hasOwnProperty(i)) {
                            url = addUrlParam(url, i, data[i]);
                        }
                    }
                } else if (typeof data != "undefined") {
                    url = appendUrl(url, data);
                }
                
                $iframe.attr("src", url);
            }

            //$content.css({ marginTop: -($content.outerHeight(false) / 2) });

            $overlay.fadeTo("fast", settings.overlayOpacity);
            $content.animate({'left':'0px'},500);
            
        

            //if (settings.method == "POST") {
            //    
            //    var $form = settings.$form;
            //    if ($form && $form instanceof jQuery)
            //    {
            //        var originalTarget = $form.attr("target"); 
            //        $form
            //            .attr("target", "modal-frame")
            //            .data("submitted-from-modallink", true)
            //            .submit()
            //    }
            //    else
            //    {
            //        $form = $("<form />")
            //            .attr("action", url)
            //            .attr("method", "POST")
            //            .attr("target", "modal-frame")
            //            .css({ display: 'none'});
            //
            //        $("<input />").attr({ type: "hidden", name: "__sparklingModalInit", value: 1 }).appendTo($form);
            //
            //        if ($.isArray(data)) {
            //            for (var i in data) {
            //                $("<input />").attr({ type: "hidden", name: data[i].name, value: data[i].value }).appendTo($form);
            //            }
            //        }
            //        else
            //        {
            //            for (var i in data) {
            //                $("<input />").attr({ type: "hidden", name: i, value: data[i] }).appendTo($form);
            //            }
            //        }
            //
            //        $form
            //            .appendTo("body")
            //            .submit();
            //
            //        $form.remove();
            //    }
            //}

            if (disableScroll) {
                hideBodyScroll(settings.onHideScroll);
            }
        }
    };

    $.fn.modalLink = function(method) {
        // Method calling logic
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.modalLink');
            return this;
        }
    };
    
    $.modalLink = function(method) {
        // Method calling logic
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.modalLink');
            return this;
        }
    };

    $.modalLink.open = function(url, options) {
        options = $.extend({}, options);
        options.url = url;
        methods["open"].call(this, $("<a />"), options);
    };

})(jQuery);


$(document).keyup(function(e) {

    if (e.keyCode == 27) {
        $.modalLink("close");
    }   
});
//---------------------------------------//
// свг спрайт
//---------------------------------------//
(function( window, document ){
    'use strict';
    var file     = '/static/img/svg.html',
        revision = 1;
    if( !document.createElementNS || !document.createElementNS( 'http://www.w3.org/2000/svg', 'svg' ).createSVGRect )
        return true;
    var isLocalStorage = 'localStorage' in window && window[ 'localStorage' ] !== null,
        request,
        data,
        insertIT = function()
        {
            document.getElementById('svg-sprite-container').insertAdjacentHTML( 'afterbegin', data );
        },
        insert = function()
        {
            if( document.body ) insertIT();
            else document.addEventListener( 'DOMContentLoaded', insertIT );
        };
    try
    {
        request = new XMLHttpRequest();
        request.open( 'GET', file, true );
        request.onload = function()
        {
            if( request.status >= 200 && request.status < 400 )
            {
                data = request.responseText;
                insert();
                if( isLocalStorage )
                {
                    localStorage.setItem( 'inlineSVGdata',  data );
                    localStorage.setItem( 'inlineSVGrev',   revision );
                }
            }
        }
        request.send();
    }
    catch( e ){}
}( window, document ) );

// Функция js-фильтрации проектов по категориям на странице одного проекта
// вывод других проектов на странице проекта удален по желанию клиента
//$(function() {
//
//    $('.project_menu_link').click(function (e) {
//    	e.preventDefault();
//
//    	$('.project_menu_link').removeClass('is-active');
//    	$(this).addClass('is-active');
//
//    	var id_cat = $(this).data('id');
//
//    	var items = $('.project_menu_list').find('.grid__item');
//
//    	$.map(items, function(item){
//    		if (!id_cat) {
//    			$(item).addClass('shown_item');
//    		}
//    		else {
//    			var show = 0;
//				$.map($(item).data('cat'), function(ic){
//					if (ic == id_cat) show = 1;
//				});
//
//				if (show) $(item).addClass('shown_item');
//				else $(item).removeClass('shown_item');
//    		}
//		});
//
//		$("#projects_container").isotope({ filter: '.shown_item' });
//	});
//
//});

$(function() {
    $('.header__submenu-link').click(function (e) {
    	e.preventDefault();

    	//$('.project_menu_link').removeClass('is-active');
    	//$(this).addClass('is-active');

    	var id_cat = $(this).data('id');
    	var items = $('.grid').find('.grid__item');

    	$.map(items, function(item){
    		if (!id_cat) {
    			$(item).addClass('shown_item');
    		}
    		else {
    			var show = 0;
				$.map($(item).data('cat'), function(ic){
					if (ic == id_cat) show = 1;
				});

				if (show) $(item).addClass('shown_item');
				else $(item).removeClass('shown_item');
    		}
		});

		$("#projects_container").isotope({ filter: '.shown_item' });
	});
});

$.extend($.lazyLoadXT, {
  autoInit: false,
});


(function() {
    function newWindow() {
        if($('.js-new-window').length) {
            var open = $('.js-new-window'),
                close = $('.js-popup-iframe-close'),
                popup = $('.popup-iframe'),
                wrap = $('body'),
                header = $('.header__layout'),
                iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

            //open popup
            open.on('click', function(e) {
                e.preventDefault();
                scrollWidth = window.innerWidth - document.documentElement.clientWidth;
                
                if ($('.js-popup-overlay').length) $('.js-popup-overlay').remove();
                $('.popup-iframe__inner').scrollTop(0);

                var href = $(this).attr('href');
                href += '?jsontpl=1';
                //block page
                //add hidden for desctops and androids
                wrap.append('<div class="popup-overlay js-popup-overlay"></div>');

                $('.js-popup-overlay').hide().fadeIn(500);
                
                wrap.addClass('stop-scrolling');
                wrap.css( 'padding-right', scrollWidth);
                header.css( 'padding-right', scrollWidth);
               // wrap.bind('touchmove', function(e){e.preventDefault()});

                //add hidden for ios
                //if(iOS) {
                //    $('body').css({
                //        top      : $(document).scrollTop()* -1,
                //        position : 'fixed',
                //        width    : '100%'
                //    });
                //}

                popup.addClass('visible');

                $('.popup-iframe__inner').load(href, function(){
                    $(window).lazyLoadXT();
                });

                $('.js-popup-overlay').on('click', function(e) {
                    close.trigger('click');
                });
            });
            
            //close popup
            close.on('click', function() {
                    popupClose();
            });
            $(document).keyup(function(e) {
                if (e.keyCode == 27) {
                    popupClose();
                }   
            });
            function popupClose() {
                $('.popup-iframe').removeClass('visible');
                setTimeout(function() {
                    // $('.popup-iframe__inner').remove();
                    // $('.popup-iframe__preloader').removeClass('hidden');
                    //remove hidden for desctops and androids
//                    wrap.removeClass('hidden');
                    wrap.removeClass('stop-scrolling');
                    wrap.css( 'padding-right', 0);
                    header.css( 'padding-right', 0);
                    wrap.unbind('touchmove')                    
                    $('.js-popup-overlay').fadeOut(500, function() {
                        $(this).remove();
                    });
                    //remove hidden for ios
                    //if(iOS) {
                    //    var offset_b = $('body').offset().top* -1;
                    //    $('body').removeAttr('style');
                    //    $(window).scrollTop(offset_b);
                    //}
                }, 500);              
            }
        }
    }
    newWindow();
}());


/* Видео на первой */
// Оригинальный пример - https://codepen.io/digistate/pen/MvapbE
var slideWrapper = $(".js-lg-slider");

// When the slide is changing
function playPauseVideo(slick, control, curSlide){
    var currentSlide, slideType, startTime, player, video;
    
    currentSlide = slick.find(".slick-current");
    slideType = currentSlide.attr("class").split(" ")[1];
    if (slideType === "video") {
        video = currentSlide.children("video").get(0);
        if (video != null) {
          if (control === "play"){
            video.play();
          } else {
            video.pause();
          }
        }
    } 
}


// DOM Ready
$(function() { 
    
    if($('.js-lg-slider').length) {
        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
          || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
          isMobile = true;
        };
        if ( isMobile ) {
            $('video').remove();
        }
        else {
            $('.slider__video').css('display','block');
        }
    }
    
  
    // Initialize
    slideWrapper.on("init", function(slick){
        slick = $(slick.currentTarget);
        setTimeout(function(){
          playPauseVideo(slick,"play");
        }, 1000);
    });
    slideWrapper.on("beforeChange", function(event, slick) {
        slick = $(slick.$slider);
        playPauseVideo(slick,"pause");
    });
    slideWrapper.on("afterChange", function(event, slick) {
        slick = $(slick.$slider);
        playPauseVideo(slick,"play");
    });

    /* Слайдер на первой */
    (function($) {
        var $slider = $('.js-lg-slider');
        if ($slider.length) {
            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                dotsClass: 'iq-slick-dots',
                fade: true,
                autoplay: true,
                autoplaySpeed: 8000,
                pauseOnHover: false,
                //customPaging: function (slider, i) {
                //    return $('<span class="slider__item-caption"></span>').text($(slider.$slides[i]).data('caption'));
                //}
            });
        }
    }($));        
});


    
$(document).ready(function() {
    /* Главное меню */
    (function($) {
    	function fixedHeader() {
    		if($('.js-fixed-header').length) {
    			var $helper = $('.js-fixed-header-helper'),
    				  $header = $('.js-fixed-header-content'),
    			 		headerHeight = $header.outerHeight();
    			$helper.css('height',headerHeight);
    			$(window).on('scroll', function() {
    				if($(document).scrollTop()>1) {
    					$('.js-fixed-header').addClass('is-slicky');
    					$('.js-fixed-header').addClass('is-slicky-menu');
    				} else if($(document).scrollTop()<=1) {
    					$('.js-fixed-header').removeClass('is-slicky');
    					$('.js-fixed-header').removeClass('is-slicky-menu');
    				}
    			})
    		}
    	}
    	fixedHeader();
    	$(window).on('resize',function() {
    		fixedHeader();
    	})
    	function submitInit() {
    		if($('.js-sumbenu-trigger').length) {
    			var open = false;
    			$('.js-sumbenu-trigger').on('click', function(e) {
    				// if(window.innerWidth<=1000) {
    					e.preventDefault();
    					var $self = $(this),
    							$item = $self.closest('.js-sumbenu-item'),
    							$container = $self.closest('.js-sumbenu-container'),
    							$allItems = $container.find('.js-sumbenu-item');
    					$allItems.not($item).removeClass('is-active');
    					$item.toggleClass('is-active');
    					open = $item.hasClass('is-active') ? true : false;
              var link = $container.find('a.is-active');
              if (document.documentElement.clientWidth >= 1000) {              
                  $('.js-sumbenu-content').css('left', calcLeftShift(link));
              }
              else {
                  $('.js-sumbenu-content').css('left', '');                
              }
    				// }
    			});
    			$(document).on('click touchend', function(e) {
    				if(open) {
    					var isBtn = !!$(e.target).closest('.js-sumbenu-trigger').length;
    					var isMenu = !!$(e.target).closest('.js-sumbenu-content').length;
    					if(!isBtn && !isMenu) {
    						$('.js-sumbenu-item').removeClass('is-active');
    						open = false;
    					}
    				}
    			});
    		}
    	}
    	submitInit();
      function calcLeftShift(self) {
          var leftShift = 0;
          if($('.js-menu-link').length && $('.js-sumbenu-content').length && self.closest('.js-submenu-overlay').length) {
            var leftThis = self.offset().left,
                leftMenu = $('.js-sumbenu-content').offset().left,
                leftMainMenu = self.closest('.js-submenu-overlay').offset().left,
                widthMenu = $('.js-sumbenu-content').outerWidth();
            leftShift = leftMenu - leftThis + 5 + (140 - self.closest('li').outerWidth()) / 2;              
            if ( leftMainMenu + leftShift + widthMenu > window.innerWidth ) {                    
               leftShift = document.documentElement.clientWidth - leftMainMenu - widthMenu - 5;
            }
          }
          return leftShift;
      }
    	function anchorsLink() {
    		if($('.js-menu-link').length) {
    			var $menuLink = $('.js-menu-link'),
    					headerHeight = $('.js-fixed-header-inner').outerHeight(),
    					firstOffset;
    			$menuLink.on('click', function(e){
              e.preventDefault();
              var $self = $(this),
                  el = $self.attr('href');
              $menuLink.removeClass('is-active');
              $self.addClass('is-active is-click');
              if (!$self.hasClass('js-noscroll')) {
                  $('html, body').animate({
                      scrollTop: $(el).offset().top-headerHeight}, 1000, function() {
                      $self.removeClass('is-click');
                  });
              }
              if (document.documentElement.clientWidth >= 1000) {
                  $self.closest('.js-sumbenu-content').css('left', calcLeftShift($self));
              }
    			});
    			$(window).on('resize', function() {
              var self = $('.js-sumbenu-container').find('a.is-active');
              if (document.documentElement.clientWidth >= 1000) {
                  $('.js-sumbenu-content').css('left', calcLeftShift(self));
              }
              else {
                  $('.js-sumbenu-content').css('left', '');
              }
    			});
    			function firtsBlockInspection() {
    				$menuLink.each(function (i) {
    					if(i==0) {
                  if (!$(this).hasClass('js-noscroll')) {
          						firstOffset = $($(this).attr('href')).offset().top;
                  }
    					}
    				});
    			}
    			firtsBlockInspection();
    			$(window).on('resize',function() {
    				firtsBlockInspection();
    			});
    			$(window).on('scroll.change-anchors', function() {
    				if(!$menuLink.hasClass('is-click') && !$menuLink.hasClass('js-noscroll')) {
    			    var scrollPos = $(document).scrollTop();
    			    $menuLink.each(function (i) {
    			        var $currLink = $(this);
    			        var refElement = $($currLink.attr('href'));
    			        if (refElement.offset().top <= scrollPos+headerHeight && refElement.offset().top + refElement.outerHeight() > scrollPos+headerHeight && !$currLink.hasClass('is-active')) {
    			            $menuLink.removeClass('is-active');
    			            $currLink.addClass('is-active');
                      if (document.documentElement.clientWidth >= 1000) {
                          $currLink.closest('.js-sumbenu-content').css('left', calcLeftShift($currLink));
                      }
    			        } else if(scrollPos+headerHeight<=firstOffset && $menuLink.hasClass('is-active')) {
                      $menuLink.removeClass('is-active');
    			        }
    			    });
    			  }
    			});
    		}
    	}
    	anchorsLink();
    }($));
  

    (function() {
        var menuLink  = $('.header__menu-icon_link'),
            header = $('.js-fixed-header');
            headerSubmenu = $('.header__submenu');
        menuLink.on('click', function(e) {
      			e.preventDefault();
   					header.removeClass('is-slicky-menu');
        });
        $(document).on('click',function (e) {
          if (header.hasClass('is-slicky') && !header.hasClass('is-slicky-menu')) {
            var container = $('.project');
            if ( $(e.target).closest('.header__submenu').length === 0
                && $(e.target).closest('.header__submenu-item').length === 0
                && $(e.target).closest('.header__inner').length === 0){
                e.preventDefault();
                header.addClass('is-slicky-menu');
                e.stopPropagation();
            }
          }
        });
    }());
    
    
    $(".modal-link").modalLink({
        height: '100%',
        width: '100%',
        showTitle: false,
        showClose: false
    });
    
    (function (w) {
        $(".close-modal").on('click', function (e) {
            e.preventDefault();
            w.$.modalLink("close");
        });
    })(window.parent);
    
    (function (w) {
        var $link;
        $(".close-modal-and-go").on('click', function (e) {
            e.preventDefault();
            $link = e.currentTarget.href;
            w.$.modalLink("close", function() {
              w.$.modalLink("open", $(e), {
                  url: $link,
                  title: '.',                
                  height: '100%',
                  width: '100%',
                  showTitle: false,
                  showClose: false
              });            
            });
        });
    })(window.parent);
        
    
    (function() {
    	var $block      = $('.js-text-block'),
          $btn        = $('.js-text-block-btn'),
          $blockInner = $block.find('.project-info__cols-inner'),
          $colLeft    = $block.find('.project-info__col--left'),
          $colRight   = $block.find('.project-info__static');
    	if ($block.length) {
        if ($block.outerHeight() > $blockInner.outerHeight()) {
          $('.project-info__more').css('display','none');
          $('.project-info__btn').css('display','none');
          $block.css('height', $blockInner.outerHeight() + 50);
        };

        if ($colRight.outerHeight() < $block.outerHeight() && $colLeft.outerHeight() > $block.outerHeight()) {
          $('.project-info__more').css('left','0');
        };
        
    		$btn.on('click', function(e) {
    			e.preventDefault();
    			if (!$(this).hasClass('active')) {
    				$block.addClass('animate');
    				$block.animate({
    					height: $blockInner.outerHeight() + 50,
    					duration: 0
    				});
    				// setTimeout(function() {
    					$btn.addClass('active');
    				// }, 500)
    			} else {
    				$block.removeClass('animate');
    				$block.removeAttr('style');
    				$btn.removeClass('active');
    			}
    		});
    		$(window).on('resize', function() {
    			if ($block.attr('style') != undefined) {
    				$block.css('height', $blockInner.outerHeight() + 50)
    			}
    		});
    	}
    })();    
    
    (function($) {    
        function loadAll() {
            $.extend($.lazyLoadXT, {
              srcAttr: 'data-lazy-src',
              selector: 'img[data-lazy-src],video,iframe[data-lazy-src]',
              forceLoad: true
            });
            $(window).lazyLoadXT();  
        };
        if($('.board').length) {
            var url = $('.board').attr('data-bg-src');
            $('<img>').attr('src',url).on('load', function(){
                $('.board').css({'backgroundImage':'url('+url+')','backgroundSize':'cover'}).removeAttr('data-bg-src');
                loadAll();
            });
        }
        else {
            loadAll();
        };
    })(jQuery);



    (function() {
        $('.go-top').click(function(event) {
            var scrolled = window.pageYOffset || document.documentElement.scrollTop;
            if (scrolled > 10 ) {
                event.stopPropagation();
                $('html, body').animate({scrollTop: 0},500);
                return false;
            }
        })
        
        $('.js-text-block-btn').on('click', function(e){
            e.preventDefault();
            $('.project-info__more').toggle();
        });    
    })();    



    /*  Сдвигаем название проекта вниз экрана */
    (function(){
      if ( !/^((?!chrome|android).)*safari/i.test(navigator.userAgent) ) {
        function TitleDown() {
            var h = document.documentElement.clientHeight - 67;
            if (h < 450) { h = 450; }
            $('div.project-page').css('marginTop', function(index, value) {
                return h;
            });
            $('div.board').css('height', function(index, value) {
                return h;
            });
            $('#project-info').css('paddingTop', 9);
        }
        TitleDown();
        
        $(window).on('resize', function() {
            TitleDown();
        })
      }
    })();

    
    /*  Управляем положением стрелок Назад и Вверх на странице проекта */
    ;(function($) {
    	function showNavArrows() {
    		if($('.project-page').length) {
    			var prPage = $('#project-page'),
    				  prInfo = $('#project-info'),
              navArrow = $('#nav-arrow'),
              projectBack = $('.project-back'),
    			 		prHeight, scrollY;
    			$(window).on('scroll', function() {
              prHeight = prPage.offset().top + prInfo.outerHeight() / 2;
              scrollY = $(document).scrollTop();
              if(scrollY > prHeight) {
                  navArrow.css('display','block');
              } else {
                  navArrow.css('display','none');
              }
              if(scrollY < 40) {
                  prInfo.css('paddingTop', scrollY + 9);
              } else {
                  prInfo.css('paddingTop', '49');                        
              }
              if(navArrow.offset().top > projectBack.offset().top + 10 || $(window).scrollTop()+$(window).height()>=$(document).height()) {
                  navArrow.css('top',projectBack.offset().top - scrollY - 7);
              } else {
                  navArrow.css('top','');                
              }
    			})
    		}
    	}
    	showNavArrows();
    	$(window).on('resize',function() {
    		showNavArrows();
    	})
    }($));
    

    /* Слайдеры на странице проекта и доп. кнопки листания */   
    $('.project-gallery__slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        var page_block = '.slider_page_' + this.id;
        $(page_block).text(i + '/' + slick.slideCount);
    });

    $('.slick-prev-add').on('click', function () {
        slide_num = this.id.substring(11);
        $('.project-gallery__slider#'+slide_num).slick("slickPrev");
    });    
    
    $('.slick-next-add').on('click', function () {
        slide_num = this.id.substring(11);
        $('.project-gallery__slider#'+slide_num).slick("slickNext");
    });    
    
    $('.project-gallery__slider').slick({
        arrows: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        prevArrow: '<div class="slick-prev slick-prev-area" aria-label="Previous"></div>',
        nextArrow: '<div class="slick-next slick-next-area" aria-label="Next"></div>',    
    });

    if(window.location.pathname=='/'){
        Cookies.set('page', 'main');
    }else{
        Cookies.set('page', window.location.pathname);      
    };

    /* Одновременное подсвечивание ссылок */
    /* Страница проекта и ссылки "Назад к проектам" */
    var back = $('.back'), 
        navArrowBack = $('.nav-arrow__back-icon'),
        btnWhite = $('.btn_white'),
        projectBackIcon = $('.project-back__icon');
    btnWhite.hover(
        function(){
            if (navArrowBack.length) {
              navArrowBack.css({ "fill": "#333333", "-webkit-transition": "fill .3s", "transition": "fill .3s" });
            }
        },
        function(){
            if (navArrowBack.length) {
              navArrowBack.css({ "fill": "", "-webkit-transition": "", "transition": "" });
            }
        }
    );
    back.hover(
        function(){
              btnWhite.css({ "color": "#333333", "-webkit-transition": "color .3s", "transition": "color .3s" });
              projectBackIcon.css({ "fill": "#333333", "-webkit-transition": "fill .3s", "transition": "fill .3s" });
        },
        function(){
              btnWhite.css({ "color": "", "-webkit-transition": "", "transition": "" });
              projectBackIcon.css({ "fill": "", "-webkit-transition": "", "transition": "" });
        }
    );
    
    
    /* Одновременное подсвечивание ссылок слайдера */
    var slickNextArea = $('.slick-next-area'), 
        slickPrevArea = $('.slick-prev-area'),
        sliderArrowNext = $('.slider_page__arrow-next'),
        sliderArrowPrev = $('.slider_page__arrow-prev');
    slickNextArea.hover(
        function(){
            if (sliderArrowNext.length) {
              sliderArrowNext.css({ "fill": "#333333", "-webkit-transition": "fill .3s", "transition": "fill .3s" });
            }
        },
        function(){
            if (sliderArrowNext.length) {
              sliderArrowNext.css({ "fill": "#d4d4d4", "-webkit-transition": "fill .3s", "transition": "fill .3s" });
            }
        }
    );
    slickPrevArea.hover(
        function(){
            if (sliderArrowPrev.length) {
              sliderArrowPrev.css({ "fill": "#333333", "-webkit-transition": "fill .3s", "transition": "fill .3s" });
            }
        },
        function(){
            if (sliderArrowPrev.length) {
              sliderArrowPrev.css({ "fill": "#d4d4d4", "-webkit-transition": "fill .3s", "transition": "fill .3s" });
            }
        }
    );

    /* Убираем подсвечивание стрелок "следующий-предыдыщий" после нажатия на часть изображения в слайдере на мобильниках */
    slickNextArea.on({ 'touchstart' : function(){
      setTimeout(function() {
        if (sliderArrowNext.length) {
              sliderArrowNext.css({ "fill": "#d4d4d4", "-webkit-transition": "fill .3s", "transition": "fill .3s" });
            }
      }, 400);
    } });
    slickPrevArea.on({ 'touchstart' : function(){
      setTimeout(function() {
            if (sliderArrowPrev.length) {
              sliderArrowPrev.css({ "fill": "#d4d4d4", "-webkit-transition": "fill .3s", "transition": "fill .3s" });
            }
      }, 400);
    } });
    
    /* Убираем подсвечивание стрелки "вверх" после нажатия на нее на мобильниках */
    $('.nav-arrow__top-icon').on({ 'touchstart' : function(){
      setTimeout(function() {
         $('.nav-arrow__top-icon').css({ "fill": "#d4d4d4", "-webkit-transition": "fill .3s", "transition": "fill .3s" });
      }, 1000);
    } });

    /* Страница проекта и ссылки "Читать далее" */
    var moreLink = $('.project-info__more-link'), 
        moreBtn  = $('.project-info__btn'),
        moreArrow = $('.info-arrow__icon');
    moreLink.hover(
        function(){
            if (moreArrow.length) {
              moreArrow.css({ "fill": "#333333", "-webkit-transition": "fill .3s", "transition": "fill .3s" });
            }
        },
        function(){
            if (moreArrow.length) {
              moreArrow.css({ "fill": "", "-webkit-transition": "", "transition": "" });
            }
        }
    );
    moreBtn.hover(
        function(){
            if (moreLink.length) {
              moreLink.css({ "color": "#333333", "-webkit-transition": "color .3s", "transition": "color .3s" });
            }
        },
        function(){
            if (moreLink.length) {
              moreLink.css({ "color": "", "-webkit-transition": "", "transition": "" });
            }
        }
    );

    
    if($('.js-grid').length) {
        $('.js-grid').isotope({
            layoutMode : 'masonry',
            packery: {
              columnWidth: '.js-grid-item'
            },
            itemSelector: '.js-grid-item',
            percentPosition: true
        });
    }    
  
});



$(window).on('load', function () {
    $('.move-iframe__preloader').remove();
});



$(window).on('load', function() {
    if($('.js-grid').length) {
        var timerId = setTimeout(function place() {
            $('.js-grid').isotope();
            timerId = setTimeout(place, 100);
        }, 100);
        
        setTimeout(function() {
           clearTimeout(timerId);  
        }, 4000);
        
    }
});



//---------------------------------------//// Подключаем набор написаных скриптов (requare/developRequare.js)//---------------------------------------//// выполняем их после того, как DOM построится$(document).ready(function () {    //---------------------------------------//    // Подключаем скрипты компонентов страниц ( modules )    //---------------------------------------//    ;(function() {    	function autoFooter() {    		var footer = $('.footer'),    			footerHeight = footer.outerHeight(),    			wrapper = $('.wrapper');    			wrapper.css('padding-bottom', footerHeight);    			wrapper.css('margin-bottom', -footerHeight);    			if($('.js-footer-placeholder').length) {    				$('.js-footer-placeholder').css('height', footerHeight);    			}    	}    	function footerVisibiblity() {    		if($('.index .footer').length) {    			$(window).on('scroll', function() {    				var    					footer = $('.index .footer'),    					mainContent = $('.index-content').offset().top,    					windowScroll = $(window).scrollTop();    				if(windowScroll > mainContent) {    					footer.addClass('visible');    				} else {    					footer.removeClass('visible');    				}    			})    		}    	}    	footerVisibiblity();    	$(window).on('load', function() {    		autoFooter();    	})    	$(window).on('resize', function() {    		autoFooter();    	})    }());    //;(function($) {    //	$(window).on('load', function() {    //    //		if($('.js-grid').length) {    //			$('.js-grid').isotope({    //				layoutMode : 'masonry',    //				packery: {    //					columnWidth: '.js-grid-item'    //				},    //				itemSelector: '.js-grid-item',    //				percentPosition: true    //			});    //		}    //	})    //}($));    //;(function($) {    //	function fixedHeader() {    //		if($('.js-fixed-header').length) {    //			var $helper = $('.js-fixed-header-helper'),    //				  $header = $('.js-fixed-header-content'),    //			 		headerHeight = $header.outerHeight();    //			$helper.css('height',headerHeight);    //			$(window).on('scroll', function() {    //				if($(document).scrollTop()>1) {    //					$('.js-fixed-header').addClass('is-slicky');    //				} else if($(document).scrollTop()<=1) {    //					$('.js-fixed-header').removeClass('is-slicky');    //				}    //			})    //		}    //	}    //	fixedHeader();    //	$(window).on('resize',function() {    //		fixedHeader();    //	})    //	function submitInit() {    //		if($('.js-sumbenu-trigger').length) {    //			var open = false;    //			$('.js-sumbenu-trigger').on('click', function(e) {    //				// if(window.innerWidth<=1000) {    //					e.preventDefault();    //					var $self = $(this),    //							$item = $self.closest('.js-sumbenu-item'),    //							$container = $self.closest('.js-sumbenu-container'),    //							$allItems = $container.find('.js-sumbenu-item');    //					$allItems.not($item).removeClass('is-active');    //					$item.toggleClass('is-active');    //					open = $item.hasClass('is-active') ? true : false    //				// }    //			})    //			$(document).on('click touchend', function(e) {    //				if(open) {    //					var isBtn = !!$(e.target).closest('.js-sumbenu-trigger').length;    //					var isMenu = !!$(e.target).closest('.js-sumbenu-content').length;    //					if(!isBtn && !isMenu) {    //						$('.js-sumbenu-item').removeClass('is-active');    //						open = false;    //					}    //				}    //			})    //		}    //	}    //	submitInit();    //	function anchorsLink() {    //		if($('.js-menu-link').length) {    //			var $menuLink = $('.js-menu-link'),    //					headerHeight = $('.js-fixed-header-inner').outerHeight(),    //					firstOffset;    //			$menuLink.on('click', function(e){    //				e.preventDefault();    //				var $self = $(this),    //				 	el = $self.attr('href'),    //					leftThis = $self.offset().left,    //					leftMenu = $('.js-sumbenu-content').offset().left;    //				$menuLink.removeClass('is-active');    //				$self.addClass('is-active is-click');    //				$('html, body').animate({    //					scrollTop: $(el).offset().top-headerHeight}, 1000, function() {    //					$self.removeClass('is-click');    //	  			});    //				if (window.innerWidth >= 1000) {    //					$self.closest('.js-sumbenu-content').css('left', leftMenu - leftThis + (130 - $self.closest('li').outerWidth()) / 2);    //				}    //			});    //			$(window).on('resize', function() {    //				if (window.innerWidth >= 1000) {    //					$('.js-sumbenu-content').css('left', '');    //				}    //			})    //			function firtsBlockInspection() {    //				$menuLink.each(function (i) {    //					if(i==0) {    //						firstOffset = $($(this).attr('href')).offset().top;    //					}    //				})    //			}    //			firtsBlockInspection();    //			$(window).on('resize',function() {    //				firtsBlockInspection();    //			})    //			$(window).on('scroll.change-anchors', function() {    //				if(!$menuLink.hasClass('is-click')) {    //			    var scrollPos = $(document).scrollTop();    //			    $menuLink.each(function (i) {    //			        var $currLink = $(this),    //						leftThis = $currLink.offset().left,    //						leftMenu = $('.js-sumbenu-content').offset().left;    //			        var refElement = $($currLink.attr('href'));    //			        if (refElement.offset().top <= scrollPos+headerHeight && refElement.offset().top + refElement.outerHeight() > scrollPos+headerHeight && !$currLink.hasClass('is-active')) {    //			            $menuLink.removeClass('is-active');    //			            $currLink.addClass('is-active');    //						if (window.innerWidth >= 1000) {    //							$currLink.closest('.js-sumbenu-content').css('left', leftMenu - leftThis + (130 - $currLink.closest('li').outerWidth()) / 2);    //						}    //			        } else if(scrollPos+headerHeight<=firstOffset && $menuLink.hasClass('is-active')) {    //		        		$menuLink.removeClass('is-active');    //			        }    //			    });    //			  }    //			})    //		}    //	}    //	anchorsLink();    //}($));    //;(function() {    //	var $block = $('.js-text-block'),    //		$btn = $('.js-text-block-btn');    //	if ($block.length) {    //		var heightFull = $block.find('.project-info__cols-inner').outerHeight() + 50;    //		$btn.on('click', function(e) {    //			e.preventDefault();    //			if (!$(this).hasClass('active')) {    //				$block.addClass('animate');    //				$block.animate({    //					height: heightFull,    //					duration: 0    //				});    //				// setTimeout(function() {    //					$btn.addClass('active');    //				// }, 500)    //			} else {    //				$block.removeClass('animate');    //				$block.removeAttr('style');    //				$btn.removeClass('active');    //			}    //		});    //		$(window).on('resize', function() {    //			if ($block.attr('style') != undefined) {    //				$block.css('height', $block.find('.project-info__cols-inner').outerHeight() + 50)    //			}    //		});    //	}    //})();    //---------------------------------------//    // Подключаем основные скрипты ( develop )    //---------------------------------------//    ;(function() {    	function slideBlock() {    		if($('.js-slide-trigger').length) {    			var holder = $('.js-slide-holder'),    				main = $('.js-slide-main');    			$('.js-slide-trigger').on('click', function() {    				var cur = $(this);    				cur.toggleClass('active');    				cur.closest(holder).toggleClass('active');    				cur.closest(holder).find(main).slideToggle(400);    			})    		}    	}    	slideBlock();    }())    // ;(function() {    // 	function parallax() {    // 		if(window.innerWidth < 768) {    // 			var    // 				headerHeight = $('.header').outerHeight();    // 				$('.index .intro').css('padding-top', headerHeight);    // 			var introHeight =  $('.intro').outerHeight();    // 				$('.index-content').css('margin-top', introHeight);    // 		} else {    // 			$('.index .intro').css('padding-top', 0);    // 			$('.index-content').css('margin-top', '100vh');    // 		}    // 	}    // 	$(window).on('load', function() {    // 		parallax();    // 	})    // 	$(window).on('resize', function() {    // 		parallax();    // 	})    // }())    ;(function() {    	function parallax() {    		if($('.index .intro').length) {    			$(window).on('scroll', function() {    				var scrollTop = $(window).scrollTop(),    					offsetY = +(-(scrollTop * .4));    				$('.index .intro').css('transform', 'translateY('+offsetY +'px)');    			})    		}    	}    	parallax();    }());    ;(function() {    	function parallax() {    		if($('.js-parallax').length) {    			$(window).on('scroll', function() {    				var scrollTop = $(window).scrollTop(),    					offsetY = +(-(scrollTop * .4));    				$('.js-parallax').css('transform', 'translateY('+offsetY +'px)');    			})    		}    	}    	parallax();    }())    ;    //(function ($) {    //    function lgSlider() {    //        var $slider = $('.js-lg-slider');    //        if ($slider.length) {    //            $slider.slick({    //                slidesToShow: 1,    //                slidesToScroll: 1,    //                arrows: false,    //                dots: true,    //                fade: true,    //                autoplay: true,    //                autoplaySpeed: 4000,    //                pauseOnHover: false,    //                customPaging: function (slider, i) {    //                    return $('<span class="slider__item-caption"></span>').text($(slider.$slides[i]).data('caption'));    //                }    //            });    //        }    //    }    //    lgSlider();    //    if ($('.js-fadein-onload').length) {    //        $('html').css('background-color', '#000');    //        setTimeout(function () {    //            $('.js-fadein-onload').addClass('shown')    //        }, 1000)    //    }    //}($));});//$(window).on('load', function () {//    if ($('.js-grid').length) {//        $('.js-grid').isotope({//            layoutMode: 'masonry',//            packery: {//                columnWidth: '.js-grid-item'//            },//            itemSelector: '.js-grid-item',//            percentPosition: true//        });//    }//});